var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongDashDotDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "64 64 896 896",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 112,478.28479 h 265.2388 v 72 H 112 Z m 412.9669,0 h 73.5191 v 72 h -73.5191 z m 114.606,0 H 912 v 72 H 639.5729 Z m -223.7758,0 h 73.5191 v 72 h -73.5191 z",
    id: "path291-3-5-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongDashDotDot);
export default __webpack_public_path__ + "static/media/LongDashDotDot.cd5b1da8226bef53440e9f9666db4065.svg";
export { ForwardRef as ReactComponent };